/**
 * Password toggle module
 * Handles show/hide password functionality
 */

export function initPasswordToggle(context: Document | HTMLElement = document): void {
  const toggleButtons = context.querySelectorAll<HTMLButtonElement>('[id="password-addon"]');
  toggleButtons.forEach((button) => {
    // Remove any existing listeners to prevent duplicates
    const newButton = button.cloneNode(true) as HTMLButtonElement;
    button.parentNode?.replaceChild(newButton, button);

    newButton.addEventListener('click', function () {
      const inputGroup = this.closest('.input-group');
      if (!inputGroup) return;

      const passwordInput = inputGroup.querySelector<HTMLInputElement>(
        'input[type="password"], input[type="text"]'
      );
      if (!passwordInput) return;

      // Toggle password visibility
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        inputGroup.classList.add('password-visible');
      } else {
        passwordInput.type = 'password';
        inputGroup.classList.remove('password-visible');
      }
    });

    // Set initial aria-label
    newButton.setAttribute('aria-label', 'Show password');
  });
}
